<div class="modal-header">
  <h5 class="modal-title">Import</h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-field-viewer [Campi]="campiImport" [Oggetto]="send" ></app-field-viewer>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" [disabled]="!enableUploadBtn" (click)="closeModal()">Annulla</button>
  <button type="button" class="btn btn-primary" [disabled]="!enableUploadBtn"  (click)="importa()">Importa <span class="ml-1 text-white font-weight-bold" *ngIf="!enableUploadBtn">{{uploadPercent}}%</span></button>
</div>
